// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"i1-z","displaySixCardTiles":"j1-z"};